import * as React from 'react';

interface CloseOutlinedIconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
  width?: number;
  height?: number;
}

const CloseOutlinedIcon: React.FC<CloseOutlinedIconProps> = ({
  fillColor = 'black',
  width = 24,
  height = 24,
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
      fill={fillColor}
    />
  </svg>
);

export default CloseOutlinedIcon;
